import React from "react";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { ErrorMessage, Field } from "formik";

const NotesStep = () => {
  const NOTES_STEP_STRINGS = GeneralStrings.ENROLL.FORM_LABELS.NOTES_STEP;

  return (
    <div className="step">
      <h4 className="step-header">{NOTES_STEP_STRINGS.HEADER}</h4>
      <div className="question-container">
        <div className="form-group">
          <Field
            as="textarea"
            name="notes"
            className="form-control"
            placeholder={GeneralStrings.FORM.FORM_LABELS.MESSAGE}
          />
          <ErrorMessage component="span" className="form-error" name="notes" />
        </div>
      </div>
    </div>
  );
};

export default NotesStep;
